import { ProtocolConfig } from "@silo/types";
import { satisfies } from "effect/Function";
import { MARKET_ADDRESS } from "../market-address";

export const local = satisfies<ProtocolConfig>()({
  firstBridgeSymbol: "ETH",
  secondBridgeSymbol: null,
  marketWhitelist: new Set([
    MARKET_ADDRESS.local.WBTC,
    MARKET_ADDRESS.local.CRV,
  ]),
  pinnedMarkets: [],
  markets: {},
  nativeRewards: null,
} as const);
